import DownloadStorageManage from './download-storage-manage';

export const bleedDefaultValues = {
  cm: 0.4,
  mm: 4,
  in: 0.125,
  px: 15
};

const tool = INKIVE.Tool.getInstance();

export const toggleManualBleedingRadioButtons = (event) => {
  const radioBleedType = document.querySelectorAll('div[data-id=download] li.filter-bleed-type');
  const checkIncludeBleed = document.querySelector('div[data-id=download] input[name="includeManualBleed"]');
  radioBleedType.forEach(radioBleedType => { radioBleedType.classList.toggle('hidden'); });
  checkIncludeBleed.checked = !checkIncludeBleed.checked;

  DownloadStorageManage.saveFieldOnStore(checkIncludeBleed, 'downloadOptions');

  if (checkIncludeBleed.checked) {
    showCanvasBleed();
    defaultBleedValues();
  } else {
    hideCanvasBleed();
  }

  preventDisable();
  event.stopPropagation();
  event.preventDefault();
  preventDisable();
};

export const radioToggleCheck = (event) => {
  const radioButton = event.currentTarget;

  if (radioButton.checked === false) { event.preventDefault(); }
  if (radioButton.name === 'isAutomaticBleed') {
    automaticBleedDefault();
  }

  DownloadStorageManage.saveFieldOnStore(event.currentTarget, 'downloadOptions');

  showCanvasBleed();
  preventDisable();
};

export const setManualBleed = () => {
  const downloadManualBleedInputBox = document.querySelector('#manualBleedValue');
  const editorManualBleedInput = document.querySelector('input[name=bleed-value-set]');
  downloadManualBleedInputBox.blur();

  if (downloadManualBleedInputBox.value < 0) {
    downloadManualBleedInputBox.value = 0;
  }

  DownloadStorageManage.saveFieldOnStore(downloadManualBleedInputBox, 'downloadOptions');

  INKIVE.Tool.getInstance().editor.canvas.runExtensions('modifyBleedValues', { size: downloadManualBleedInputBox.value });
  editorManualBleedInput.value = downloadManualBleedInputBox.value;
  preventDisable();
};

export const updateManualBleed = () => {
  const manualBleedInputBox = document.querySelector('#manualBleedValue');
  let pressedKeyTimer = 0;
  manualBleedInputBox.addEventListener('keydown', (event) => {
    clearTimeout(pressedKeyTimer);
    switch (event.key) {
      case '-':
      case 'e':
      case '+':
      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowLeft':
      case 'ArrowRight':
        event.preventDefault();
        return;

      case 'Delete':
        manualBleedInputBox.value = 0;
        return;

      case 'Backspace':
        return;

      case 'default':
        return;
    }

    pressedKeyTimer = setTimeout(() => setManualBleed(), 750);
  });
};

export const updateBleedSize = () => {
  // update the values on the input box (mostly for visual purposes).
  const currentStorage = DownloadStorageManage.getStorageTemplate('downloadOptions');
  const bleedsize = currentStorage && currentStorage.manualBleedValue
    ? [currentStorage.manualBleedValue]
    : INKIVE.C.BLEED_VALUES.bleedSize.split(' ');
  const manualBleedInput = document.querySelector('div[data-id=download] #manualBleedValue');
  const bleedUnit = INKIVE.C.BLEED_VALUES.bleedUnit;

  manualBleedInput.placeholder = bleedsize[0];
  manualBleedInput.value = bleedsize[0];
  document.querySelector('.desygner-custom-check .bleed-unit ').innerHTML = bleedUnit;
};

export const showCanvasBleed = () => {
  tool.editor.canvas.runExtensions('showBleedClipper', { keepDisabled: true });
  tool.editor.canvas.runExtensions('enableGuideLine', { keepVisible: true });

  const downloadManualBleedInputBox = document.querySelector('#manualBleedValue');
  downloadManualBleedInputBox.blur();

  preventDisable();
};

export const preventDisable = () => {
  document.querySelector('header').classList.remove('disabled');
  document.querySelector('#tool-panel .tool-panel-inner .tool-menu').classList.remove('disabled');
  document.querySelector('#tool-panel .tool-panel-inner .tool-content').classList.remove('disabled');
  document.querySelector('#pages-panel').classList.remove('disabled');
};

export const hideCanvasBleed = () => {
  tool.editor.canvas.runExtensions('hideBleedClipper', { keepDisabled: false });
  tool.editor.canvas.runExtensions('disableGuideLine', { keepVisible: false });
};

export const uncheckBleedOption = () => {
  const radioBleedType = document.querySelectorAll('div[data-id=download] li.filter-bleed-type');
  document.querySelector('input[name="isBleed"]').checked = false;
  document.querySelector('input[name="isAutomaticBleed"]').checked = false;

  radioBleedType.forEach(radioBleedType => radioBleedType.classList.add('hidden'));
};

export const defaultBleedValues = () => {
  const projectPageLimit = INKIVE.C.BOOK.num_pages < 16;
  const radioAutoBleed = document.querySelector('div[data-id=download] input[name="isAutomaticBleed"]');
  const autoBleedLine = document.querySelector('div[data-id=download] .bleed-type-auto');
  const infoIcon = document.querySelector('div[data-id=download] .icon-info');
  const infoIconMaxPages = document.querySelector('div[data-id=download] .icon-info-max-pages');
  const checkIncludeBleed = document.querySelector('div[data-id=download] input[name="includeManualBleed"]');

  autoBleedLine.classList.toggle('disabled', !projectPageLimit);
  radioAutoBleed.classList.toggle('disabled', projectPageLimit);

  setLastSavedBleedOptionsValue();

  infoIcon.classList.toggle('hide-icon', !projectPageLimit);
  infoIconMaxPages.classList.toggle('hide-icon', projectPageLimit);

  if (!projectPageLimit) checkIncludeBleed.checked = true;

  preventDisable();
};

export const setLastSavedBleedOptionsValue = () => {
  const currentDownloadStorage = DownloadStorageManage.getStorageTemplate('downloadOptions');

  if (currentDownloadStorage && currentDownloadStorage.checkBox.isAutomaticBleed) {
    automaticBleedOption(currentDownloadStorage);
  } else {
    manualBleedOption(currentDownloadStorage);
  }
};

const manualBleedOption = (currentDownloadStorage) => {
  const inputManualBleedValue = document.querySelector('div[data-id=download] #manualBleedValue');
  const radioManualBleed = document.querySelector('div[data-id=download] input[name="isBleed"]');
  radioManualBleed.checked = true;
  inputManualBleedValue.classList.toggle('disabled', false);
  const bleedUnit = INKIVE.C.BLEED_VALUES.bleedUnit;

  inputManualBleedValue.value = currentDownloadStorage && currentDownloadStorage.manualBleedValue
    ? currentDownloadStorage.manualBleedValue
    : bleedDefaultValues[bleedUnit];
};

const automaticBleedOption = (currentDownloadStorage) => {
  const inputManualBleedValue = document.querySelector('div[data-id=download] #manualBleedValue');
  const radioAutoBleed = document.querySelector('div[data-id=download] input[name="isAutomaticBleed"]');
  radioAutoBleed.checked = true;
  inputManualBleedValue.classList.toggle('disabled', true);

  const bleedUnit = INKIVE.C.BLEED_VALUES.bleedUnit;
  inputManualBleedValue.value = currentDownloadStorage.manualBleedValue
    ? currentDownloadStorage.manualBleedValue
    : bleedDefaultValues[bleedUnit];
};

const automaticBleedDefault = () => {
  const bleedUnit = INKIVE.C.BLEED_VALUES.bleedUnit;

  tool.editor.canvas.runExtensions('modifyBleedValues', { size: bleedDefaultValues[bleedUnit] });
  updateBleedSize();
};

export const recommendedBleedUnitMsg = () => {
  document.querySelector('div[data-id=download] .manual-bleed .' + INKIVE.C.BLEED_VALUES.bleedUnit).classList.toggle('hide-icon');
};

export const uncheckPDFPrintOptions = () => {
  document.querySelector('div[data-id=download] input[name="isCutmark"]').checked = false;
  document.querySelector('div[data-id=download] input[name="includeManualBleed"]').checked = false;
  document.querySelector('div[data-id=download] input[name="isCMYK"]').checked = false;
};
